import { motion } from "framer-motion";
import { MIDWEST_TEXTURE } from "../../data/media";

const CHAPTERS = [
  {
    n: "01",
    title: "Safety is not a rule. It's the foundation.",
    body: "Every session starts and ends with the same four rules. Muzzle discipline and trigger control aren't drills you graduate from — they're the ground everything else is built on.",
  },
  {
    n: "02",
    title: "Competence beats confidence.",
    body: "Confidence without skill gets people hurt. We train slow, correct, and repeatable fundamentals until they hold up under stress — not just on a calm range day.",
  },
  {
    n: "03",
    title: "Trained for the moment you hope never comes.",
    body: "Defensive skill is earned in reps, not bought in gear. We prepare you to make sound, lawful decisions — mentally and physically — if you ever have to.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={MIDWEST_TEXTURE} alt="" className="w-full h-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0 bg-brand-bg/60" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-20">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange">02 / Doctrine</span>
          <span className="h-px flex-1 bg-white/10" />
        </div>

        <div className="space-y-20 md:space-y-28">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-start"
              data-testid={`manifesto-${c.n}`}
            >
              <span className="absolute -top-16 -left-2 md:-left-6 font-heading font-black text-[9rem] md:text-[16rem] leading-none text-white/5 select-none pointer-events-none">
                {c.n}
              </span>
              <div className="md:col-span-1" />
              <h3 className="relative md:col-span-6 font-heading font-bold uppercase text-3xl md:text-5xl tracking-tighter text-brand-ink leading-[0.95]">
                {c.title}
              </h3>
              <p className="relative md:col-span-5 text-brand-muted text-base leading-relaxed md:pt-2">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
